import Api from "../../../util/Api";

export default function getInitState() {
    return {
        dataTableOptions: {
            server_mode: true,
            show_reset_button: false,
            global_search: {
                visibility: false,
            }
        },
        actions: [
            {
                btn_text: '<i class="fas fa-filter"></i> Szűrés',
                event_name: "customClick",
                class: "btn btn-primary my-custom-class",
                event_payload: 'showSearchModal'
            }
        ],
        searchFields: [
            {
                name: "documentName",
                label: "Dokumentum neve",
                formSize: 3,
                formVisible: true,
                formType: 'text',
            },
            {
                name: "documentType",
                label: "Dokumentum típusa",
                formSize: 3,
                formType: "select",
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getDocumentLogDocumentTypes,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "documentAction",
                label: "Művelet",
                formSize: 3,
                formType: "select",
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getDocumentLogDocumentActions,
                    formatText: function (val) {
                        return val.text;
                    },
                    formatOption: function (val) {
                        return val.text;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'text',
                    returnValue: 'id',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "username",
                label: "Felhasználó",
                formSize: 3,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllUserForSelect,
                    formatText: function (val) {
                        return val.lastName + ' ' + val.firstName;
                    },
                    formatOption: function (val) {
                        return val.lastName + ' ' + val.firstName;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'lastName',
                    returnValue: 'username',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "createdOnFrom",
                label: "Művelet dátuma (tól)",
                formSize: 3,
                formVisible: true,
                formType: 'date'
            },
            {
                name: "createdOnTo",
                label: "Művelet dátuma (ig)",
                formSize: 3,
                formVisible: true,
                formType: 'date'
            },
        ],
        headerFields: [
            {
                name: "id",
                label: "ID",
                sort: false,
                visibility: false
            },
            {
                name: "documentName",
                label: "Dokumentum neve",
                sort: false,
                visibility: true,
                formType: 'text',
            },
            {
                name: "documentType.text",
                label: "Dokumentum típusa",
                sort: false,
                visibility: true,
            },
            {
                name: "documentAction.text",
                label: "Művelet",
                sort: false,
                visibility: true,
            },
            {
                name: "username",
                label: "Felhasználó",
                sort: true,
                visibility: true,
                formType: 'select',
                formVisible: true,
                selectOptions: {
                    apiCallback: Api.getAllUserForSelect,
                    formatText: function (val) {
                        return val.lastName + ' ' + val.firstName;
                    },
                    formatOption: function (val) {
                        return val.lastName + ' ' + val.firstName;
                    },
                    minimumInputLength: 0,
                    searchOnServer: false,
                    filteredAttr: 'lastName',
                    returnValue: 'username',
                    locale: {
                        searchPlaceholder: 'Keresés...',
                        noResults: 'Nincs találat'
                    }
                }
            },
            {
                name: "documentActionCreatedOn",
                label: "Művelet dátuma",
                slot_name: "created_on_format",
                sort: true,
                visibility: true
            }
        ]
    }
}
